export const TOAST_ERROR = 'error';
export const TOAST_SUCCESS = 'success';
export const TOAST_NOTIFICATION = 'warning';

export default [
  TOAST_ERROR,
  TOAST_SUCCESS,
  TOAST_NOTIFICATION,
];
